import { createSelector } from '@reduxjs/toolkit';
import type { TRootState } from 'src/store/store-types';

const selectPriceBook = (entities: TRootState['entities']) => entities.priceBook;

export const selectPriceBooks = createSelector([selectPriceBook], (priceBook) => priceBook.priceBooks);

export const selectPriceBookAdding = createSelector([selectPriceBook], (priceBook) => priceBook.isAdding);

export const selectPriceBookCompanyItems = createSelector(
  [selectPriceBook],
  (priceBook) => priceBook.priceBookCompanyItems,
);
